module.exports = __webpack_public_path__ + "8962f837935c4bc55a5295a8b9b5edb6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/purple-hot-air-balloon-empty.png
// module id = 2857
// module chunks = 0